import { alpha, Box } from "@mui/material";

const matchStart = (text: string, query: string | undefined): number =>
  query ? text.toLowerCase().indexOf(query.toLowerCase()) : -1;

export const containsText = (text: string, query: string | undefined) =>
  matchStart(text, query) >= 0;

export const HighlightedText = ({
  text,
  query,
}: {
  text: string;
  query: string | undefined;
}) => {
  const start = matchStart(text, query);
  if (query === undefined || start < 0) {
    return <>{text}</>;
  }
  const end = start + query.length;
  return (
    <>
      {text.slice(0, start)}
      <Box
        component="mark"
        sx={{
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.14),
          color: "inherit",
          borderRadius: 0.25,
        }}
      >
        {text.slice(start, end)}
      </Box>
      {text.slice(end)}
    </>
  );
};
